import { Close } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Avatar, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Scrollbar } from 'app/components';
import { InspectionIcon } from 'app/icons';
import { TransportGroupCheckListForm } from 'app/pages/TransportGroup';
import { useAsyncAction } from 'app/services';
import { transportGroupCheckListCreate, transportGroupCheckListUpdate } from 'app/store/transport';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
const TransportGroupCheckListDialog = ({ open, onClose, defaultValues }) => {
    const formRef = useRef(null);
    const { groupSelectedItem } = useSelector((state) => state.transport);
    const { asyncAction: createChecklistSubmit, isLoading: createChecklistLoading, isSuccessful: isCreateChecklistSuccessful, } = useAsyncAction(transportGroupCheckListCreate, [open]);
    const { asyncAction: updateChecklistSubmit, isLoading: updateChecklistLoading, isSuccessful: isUpdateChecklistSuccessful, } = useAsyncAction(transportGroupCheckListUpdate, [open]);
    const handleFormClick = () => {
        var _a;
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.handleFormSubmit();
    };
    const handleFormSubmit = (params) => {
        if (!groupSelectedItem) {
            return;
        }
        defaultValues
            ? updateChecklistSubmit(groupSelectedItem.id, params)
            : createChecklistSubmit(groupSelectedItem.id, params);
    };
    useEffect(() => {
        if (isCreateChecklistSuccessful || isUpdateChecklistSuccessful) {
            onClose();
        }
    }, [isCreateChecklistSuccessful, isUpdateChecklistSuccessful]);
    return (React.createElement(Dialog, { maxWidth: 'md', fullWidth: true, open: open, onClose: onClose, sx: (theme) => ({
            width: '100%',
            height: '100%',
            '.MuiDialog-paper': {
                minWidth: '500px',
            },
            '.MuiDialogTitle-root': {
                display: 'flex',
                padding: theme.spacing(2),
                alignItems: 'center',
            },
            '.MuiDialogTitle-root .MuiTypography-root': {
                marginLeft: theme.spacing(1.5),
            },
            '.MuiDialogTitle-root .MuiButtonBase-root': {
                marginLeft: 'auto',
            },
            '.MuiDialogContent-root': {
                padding: theme.spacing(0),
            },
            '.MuiDialogContent-root .simplebar-container': {
                padding: theme.spacing(0, 2),
            },
            '.MuiDialogActions-root': {
                padding: theme.spacing(2),
                justifyContent: 'flex-end',
            },
            '.MuiAvatar-circular': {
                bgcolor: alpha(theme.palette.primary.main, 0.12),
                svg: {
                    width: '18px',
                    height: '18px',
                },
                'path, circle': {
                    fill: theme.palette.primary.main,
                },
            },
            '.MuiAlert-root': {
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(2),
                borderRadius: theme.shape.borderRadius,
            },
        }) },
        React.createElement(DialogTitle, null,
            React.createElement(Avatar, null,
                React.createElement(InspectionIcon, { fontSize: 'small' })),
            React.createElement(Typography, { component: 'p' }, defaultValues ? 'Изменить чеклист' : 'Добавить чеклист'),
            React.createElement(IconButton, { color: 'default', onClick: onClose },
                React.createElement(Close, { fontSize: 'small' }))),
        React.createElement(DialogContent, null,
            React.createElement(Scrollbar, null,
                React.createElement(TransportGroupCheckListForm, { ref: formRef, defaultValues: defaultValues, onSubmit: handleFormSubmit }))),
        React.createElement(DialogActions, null,
            React.createElement(LoadingButton, { variant: 'contained', color: 'primary', loading: createChecklistLoading || updateChecklistLoading, onClick: handleFormClick, disableElevation: true }, defaultValues ? 'Сохранить изменения' : 'Добавить'))));
};
export default TransportGroupCheckListDialog;
